import React, { useEffect } from "react";
import WebKalkulator from "../../WebKalkulator/View";
import { useParams } from "react-router-dom";

const EditOffer = ({ state, actions }) => {
  const { id } = useParams();

  useEffect(() => {
    actions.getOfferById(id);
  }, []);

  return (
    state.offerToEdit && (
      <WebKalkulator isAddOffer={false} state={state} actions={actions} />
    )
  );
};

export default EditOffer;
